module.exports = __webpack_public_path__ + "static/media/folder.0748cf2e.svg";